import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../redux/slices/authSlice";
import AuthLayout from "../components/AuthLayout";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ForgotPasswordPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { forgotPasswordStatus, forgotPasswordError } = useSelector((state) => state.auth);
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    const payload = { email }; // Explicitly define the payload
    //console.log("Dispatching payload:", payload); // Debug log
    dispatch(forgotPassword(payload));
  };

  useEffect(() => {
    if (forgotPasswordStatus === "succeeded") {
      toast.success("Password reset link sent to your email!");
      setTimeout(() => navigate('/login'), 3000);
    } else if (forgotPasswordStatus === "failed") {
      toast.error(forgotPasswordError?.email?.[0] || "An error occurred. Please try again.");
    }
  }, [forgotPasswordStatus, forgotPasswordError, navigate]);

  return (
    <AuthLayout activeTab="login">
      <div className="welcome-message">
        <h3 className="text-center mb-4">Reset Your Password</h3>
        <p className="text-muted text-center mb-4">
          Enter your email address and we'll send you a link to reset your password.
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="email" className="form-label text-muted">
            Email Address
          </label>
          <input
            type="email"
            className="form-control custom-input"
            id="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value.trim())}
            required
          />
          {forgotPasswordError && (
            <div className="text-danger mt-2">{forgotPasswordError?.email?.[0] || "Error occurred"}</div>
          )}
        </div>

        <button
          type="submit"
          className="btn btn-primary w-100 custom-btn"
          disabled={forgotPasswordStatus === "loading"}
        >
          {forgotPasswordStatus === "loading" ? "Sending..." : "Send Reset Link"}
        </button>
      </form>

      <div className="text-center mt-3">
        <a href="/login" className="text-warning text-decoration-none">
          Back to Login
        </a>
      </div>

      <ToastContainer />
    </AuthLayout>
  );
};

export default ForgotPasswordPage;